const SCENE_HEIGHT_REL = 0.3

const TRAIN_WIDTH_REL = 0.25
const TRAIN_REAL_WIDTH_M = 100

export {
  SCENE_HEIGHT_REL,
  TRAIN_WIDTH_REL,
  TRAIN_REAL_WIDTH_M
}

export default class SceneGeometry {
  constructor (sceneWidth) {
    this.sceneWidth = sceneWidth
  }

  _trainWidthPx () {
    return this.sceneWidth * TRAIN_WIDTH_REL
  }

  m2px (objM) {
    let trainPx = this._trainWidthPx()
    return trainPx * objM / TRAIN_REAL_WIDTH_M
  }

  px2m (objPx) {
    let trainPx = this._trainWidthPx()
    return TRAIN_REAL_WIDTH_M * objPx / trainPx
  }
}
